import { useMemo } from 'react'
import { apiUrl } from 'constants/api'
import useFetch from 'hooks/useFetch'
import BookCard from 'components/BookCard'
import Container from 'components/common/Container'
import Heading from 'components/common/Heading'
import Spinner from 'components/common/Spinner'


const DisplayFullInfo = () => {
    const { data, loading } = useFetch({
        url: `${apiUrl}/api/books?bibkeys=ISBN:9783442236862&jscmd=details&format=json`
    });

    const bookData = useMemo(() => {
        if(!data) return {};

        const { details } = Object.values(data)[0];

        return details;
    }, [data]);
    
    return (
        <Container className="py-4">
            <section>
                <Heading className="mb-4">
                    1. Display full info
                </Heading>

                <div className="mb-4">
                    <p className="mb-2">
                        https://openlibrary.org/api/books?bibkeys=ISBN:9783442236862&jscmd=details&format=json Display info for one book
                    </p>

                    <p className="mb-2">
                        Cover image | Title | authors | publish_date | physical_format

                        Cover image should be large (-L)
                    </p>
                </div>
            </section>

            <section>
                <Heading as="h3" className="mb-2">
                    Solution
                </Heading>

                <div className="w-80">
                {
                    loading ? (
                        <Spinner />
                    ) : (
                        data && <BookCard data={bookData} />
                    )
                }
                </div>
            </section>

        </Container>
    )
}

export default DisplayFullInfo